import * as React from 'react'
import { Route, Routes } from 'react-router-dom'

import { ResourceHeader } from '@factorialco/f0-react/dist/experimental'
import { ItAssetDetailsDocument } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'
import { buildNavigation } from 'modules/core/lib/react-router'

const RootPage = React.lazy(() => import('modules/it_management/pages/RootPage'))

const ItManagementIndexPage = React.lazy(() => import('../pages/index'))
const UniversalImporterItAssetsModalPage = React.lazy(
  () => import('../pages/UniversalImporterItAssetsModalPage')
)
const UniversalImporterItAssetsResultPage = React.lazy(
  () => import('../pages/UniversalImporterItAssetsResultPage')
)
const EditItAssetPopup = React.lazy(() => import('../pages/EditItAssetPopup/index'))
const AssetDetailsLayout = React.lazy(() => import('../pages/AssetDetailsPage/AssetDetailsLayout'))
const AssetDetailsOverview = React.lazy(
  () => import('../pages/AssetDetailsPage/AssetDetailsOverview')
)
const AssetDocumentsPage = React.lazy(() => import('../pages/AssetDetailsPage/AssetDocumentsPage'))

export const itManagementModuleRoutes = buildNavigation((navigation) => {
  return [
    {
      path: navigation.it_management.path,
      element: <RootPage />,
      handle: {
        module: 'it_management',
        meta: () => {
          return {
            title: i18n.t('it_management.it_inventory.title'),
            description: i18n.t('it_management.it_inventory.title'),
            illustration: 'laptop-user',
          }
        },
      },
      children: [
        {
          path: '',
          element: <ItManagementIndexPage />,
          children: [
            {
              path: 'edit/:assetId',
              element: <EditItAssetPopup />,
            },
          ],
        },
        {
          path: navigation.it_management.importAssetsResult.path,
          element: (
            <Routes>
              <Route path="" element={<UniversalImporterItAssetsResultPage />} />
            </Routes>
          ),
        },
        {
          path: navigation.it_management.importAssets.path,
          element: (
            <Routes>
              <Route path="" element={<UniversalImporterItAssetsModalPage />} />
            </Routes>
          ),
          handle: {
            resource: true,
            meta: () => ({
              title: i18n.t('it_management.routes.assets_universal_importer'),
              headerComponent: (
                <ResourceHeader title={i18n.t('it_management.routes.assets_universal_importer')} />
              ),
            }),
          },
        },
        {
          path: navigation.it_management.assetId.path,
          element: <AssetDetailsLayout />,
          handle: {
            resource: true,
            meta: ({ watchQuery, params }) => {
              return watchQuery({
                query: ItAssetDetailsDocument,
                variables: {
                  id: params.assetId || '',
                },
              }).map(({ data }) => {
                const asset = data?.itManagement?.itAsset
                const assetName = asset?.itAssetModel?.name || asset?.serialNumber
                return {
                  title: assetName || i18n.t('it_management.routes.asset_details'),
                }
              })
            },
          },
          children: [
            {
              index: true,
              element: <AssetDetailsOverview />,
            },
            {
              path: navigation.it_management.assetId.documents.path,
              element: <AssetDocumentsPage />,
            },
          ],
        },
      ],
    },
  ]
})
